import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { PatientService } from 'src/app/services/patient.service';
import {
  Consultation,
  CouponCode,
  Nutrition_Health_Consultation_Plans_List
} from '../../../models/consultdoctors';
import { SpecialityService } from '../../../services/speciality.service';
import {
  order_model,
  Payment_Data,
  PaymentSuccessResult
} from 'src/app/models/basket';
import { ApiResult, PromiseResult } from '../../../models/PromiseResult';
import { CanComponentLeave } from 'src/app/guards/un-saved-changes.guard';
import { UtilitiesService } from '../../../utilities/utilities.service';
import {
  DateUtilService,
  moment_duration
} from '../../../utilities/date.util.service';
import { RefferalDiscountService } from '../../../services/refferal-discount.service';
import { TraceClassDecorator } from '@sentry/angular';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ConsultationStatusModel,
  PackageStatusModel
} from 'src/app/models/package';
import { PaymentComponent } from '../../shared/payment/payment.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from '../shared/breadcrumb.service';
import { DoctorsService } from 'src/app/services/doctors.service';
import { fetchAllData } from 'src/app/models/Doctor';
import { DaterenderService } from 'src/app/services/daterender.service';
import { CountriesService } from 'src/app/services/countries.service';
import { MessageService, SelectItem } from 'primeng';
import { TimeSlotsComponent } from '../../shared/time-slots/time-slots.component';
import { CONSULTATION_TYPES, IMAGE_PROFILE_ID_SUPPORTED_TYPES } from 'src/app/constant/constant';
import { UserService } from 'src/app/services/user.service';
import { URLS } from '../../../constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';

enum CONSULTATION_FORMS_TABS {
  CONSULTATION_FORM = 0,
  // PACKAGES_FORM = 1,
  // NUTRITIONAL_ASSESSMENT_FORM = 1,
  PAID_DIET_FORM = 1,
  OFFERS_FORM = 2,
  PAYMENT_FORMS = 3,
  PAYMENT_SUCCESS = 4
}

@Component({
  selector: 'app-consult-doctor',
  templateUrl: './consult-doctor.component.html',
  styleUrls: [
    './consult-doctor.component.css'
    // , '../../../../assets/css/custom-egd.css'
  ]
})
@TraceClassDecorator()
export class ConsultDoctorComponent implements OnInit, CanComponentLeave {
  textareaValue: string;
  isOverlayPanelVisible: boolean = false;
  dateTime = new Date();
  visible: boolean = false;
  selectedGender: any = '';
  dob: Date | undefined;
  value: '';
  showInput: string = 'fasle';
  stateList = [];
  selectedState: any = '';
  gender = [];
  email = '';
  token = '';
  patientGuid = null;
  countryId = null;
  server_error: ApiResult = new ApiResult(false);
  otpText = 'Get OTP';
  isSpinning = false;
  serviceId = '';
  errorText = '';
  disableButton = true;
  slug: string = "";
  provider_id: string = "";
  isSubmitting: boolean = false;
  is_uk_country: boolean = false;
  is_primary_provider: boolean = false;
  unique_id: SelectItem[] = [];
  identification_type: string;
  identification: File;
  private readonly image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
  @ViewChild(PaymentComponent) payment_screen: PaymentComponent;
  @ViewChild(TimeSlotsComponent) time_slots_screen: TimeSlotsComponent;
  consultation: Consultation = new Consultation(3);

  constructor(
    private readonly router: Router,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly utilitiesService: UtilitiesService,
    private readonly patientService: PatientService,
    private readonly doctorService: DoctorsService,
    private readonly specialtyService: SpecialityService,
    private readonly dateUtilService: DateUtilService,
    private readonly refferalDiscountService: RefferalDiscountService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly daterenderService: DaterenderService,
    private readonly countriesService: CountriesService,
    private readonly messageService: MessageService,
    private readonly userService: UserService,
    private readonly providerstateService: ProviderStateService
  ) {
    this.unique_id = [
      { label: 'Driving License', value: 'Driving License' },
      { label: 'Passport', value: 'Passport' },
      { label: 'Other Govt. ID', value: 'Other Govt. ID' }
    ];
    // this.consultation.other_data.p_editdata.profileCompletion.max_date = this.utilitiesService.getMaxDate();
  }

  showDialog() {
    const userId = sessionStorage.getItem('userid');
    let allowToShowForm = false;
    this.patientService
      .getMember(userId)
      .toPromise()
      .then((res) => {
        if (res.success) {
          res.data.patient.forEach((e) => {
            if (e.relation == 'self') {
              this.patientGuid = e.patient_guid;
              this.countryId = e.country_id;
              allowToShowForm = !e.profile_complete;
            }
          });
          if (allowToShowForm) {
            this.dateTime.setDate(this.dateTime.getDate());
            this.dateTime.setFullYear(this.dateTime.getFullYear() - 18);
            this.countriesService
              .getStates(this.countryId)
              .toPromise()
              .then((result) => {
                result.map((ele) => {
                  ele['state_data'] = {
                    name: ele.state_name.toString(),
                    code: ele.id.toString()
                  };
                });
                const sl = [];
                this.utilitiesService
                  .getSelectItemList(result, 'state_name', 'state_data')
                  .map((e) => {
                    sl.push(e.value);
                  });
                this.stateList = sl;
                this.gender = [
                  { name: 'Male', code: 'M' },
                  { name: 'Female', code: 'Fm' },
                  { name: 'Other', code: 'Oh' }
                ];
                this.visible = true;
              })
              .catch((err: HttpErrorResponse) => {
                console.error(err);
              });
          }
        }
      });
  }

  enableContinueButton() {
    this.errorText = '';
    if (!this.dob) {
      this.errorText = 'Date of birth is required.';
      return;
    }
    if (!this.selectedState) {
      this.errorText = 'State is required.';
      return;
    }
    if (!this.selectedGender) {
      this.errorText = 'Gender is required.';
      return;
    }

    if (this.dob && this.selectedGender && this.selectedState) {
      this.errorText = '';
      this.disableButton = false;
    }
  }

  onPopUpSubmit() {
    this.errorText = '';
    const form: FormData = new FormData();
    form.set('patient_guid', this.patientGuid);
    if (this.email) {
      form.set('e_email', this.email);
    }
    form.set('token', this.token);
    form.set('gender', this.selectedGender?.name);
    form.set('state_id', this.selectedState?.code);
    form.set('state_name', this.selectedState?.name);
    form.set('service_id', this.serviceId);
    form.set('date_of_birth', this.daterenderService.render_data(this.dob));
    form.set('identification', this.identification);
    form.set('identification_type', this.identification_type);
    this.isSubmitting = true;
    // verify otp;
    this.patientService
      .UpdateProfile(form)
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.visible = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Profile Updated SuccessFully'
          });

        } else {
          this.errorText = result.error.message;
        }
      })
      .catch((error: HttpErrorResponse) => {
        this.errorText = error.message;
        this.server_error = error.error;
        this.isSubmitting = false;
      });
  }

  toggleInput() {
    this.errorText = '';
    this.isSpinning = true;
    this.userService
      .updateCredentialsPatient(this.email)
      .toPromise()
      .then((res) => {
        if (res.success) {
          this.showInput = this.showInput == 'false' ? 'true' : this.showInput;
          this.isSpinning = false;
          this.serviceId = res.data.service_id;
          this.otpText = 'Resend OTP';
        } else {
          this.errorText = res.error.message;
          this.isSpinning = false;
        }
      })
      .catch((e: HttpErrorResponse) => {
        this.isSpinning = false;
        this.errorText = e.error.message[0];
      });
  }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerstateService.getProviderSlug();
    this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
    console.log(this.is_primary_provider, "checking");
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink: ['/', this.slug, 'patient'] },
      { label: 'Consult Doctor' }
    ]);
    this.provider_id = this.providerstateService.getProviderId();
    if (URLS.IS_UK) {
      this.is_uk_country = true;
    }

    this.showDialog();
    await this.getMemberList();
    this.setDates();
    await this.getDietPreference();
    await this.getDietitionList();
    // if (!this.isProfileComplete()) {
    //     await this.getStates();
    // }
    if (this.is_uk_country) {
      this.consultation.consultApiData.consultation_type_id =
        CONSULTATION_TYPES.EXPERT_SECOND_MEDICAL_CONSULTATION;
    }
    else {
      this.consultation.consultApiData.consultation_type_id =
        CONSULTATION_TYPES.PRIMARY_MEDICAL_CONSULTATION;
    }

    await this.onConsultationChange();
    await this.setConsultationType();
    await this.setSpeciality();
    await this.setPaymentValue();
  }

  async setSpeciality() {
    this.route.queryParamMap.subscribe(async (res) => {
      if (res.get('common_health_id')) {
        if (this.is_uk_country) {
          this.consultation.consultApiData.consultation_type_id =
            CONSULTATION_TYPES.EXPERT_SECOND_MEDICAL_CONSULTATION;
        }
        else {
          this.consultation.consultApiData.consultation_type_id =
            CONSULTATION_TYPES.PRIMARY_MEDICAL_CONSULTATION;
        }

        await this.getSpecialty(this.consultation.consultApiData.patient_guid, parseInt(res.get('common_health_id')), this.provider_id);
      } else await this.getSpecialty(this.consultation.consultApiData.patient_guid, undefined, this.provider_id);
    });
  }

  async onUserPackageChange() {
    await this.getPriorityList();

  }

  async setPaymentValue() {
    this.route.queryParamMap.subscribe((res) => {
      if (res.get('payment_option')) {
        this.consultation.other_data.is_pay = Boolean(res.get('payment_option'));
      }
    });
    if (Boolean(this.consultation.other_data.is_pay)) {
      await this.onPaymentChange();
    }
  }

  async setDietDataValues() {
    this.route.queryParamMap.subscribe((res) => {
      const selectedId = parseInt(res.get('nutrition_and_health_consultation_type_id'));

      // Find the selected plan based on ID
      const selectedPlan = this.consultation.other_data.nutritionHealthCons.plans.plans_list.find(plan => plan.value.id === selectedId);

      if (selectedPlan) {
        this.consultation.other_data.selectedDietPlan = selectedPlan.value;
      } else {
        console.log("Plan not found for ID:", selectedId);
      }
    });


  }




  async setConsultationType() {
    this.route.queryParamMap.subscribe((res) => {
      if (res.get('consultation_type_id'))
        this.consultation.consultApiData.consultation_type_id = parseInt(
          res.get('consultation_type_id')
        );
    });
    if (Boolean(this.consultation.consultApiData.consultation_type_id)) {
      await this.onConsultationChange();
    }
  }

  async submitNutritionAssessmentForm() {
    // let food_list: string[] = ["breakfast", "lunch", "snack_1", "snack_2", "sleep", "water", "dinner"]
    // food_list.forEach((ele: "breakfast" | "lunch" | "snack_1" | "snack_2" | "sleep" | "water" | "dinner") => {
    //     if (this.consultation.other_data.dietFoodData.dietFoodConditon(ele)) {
    //         if (this.consultation.other_data.dietFoodData[ele].properties[0].isTime)
    //             this.consultation.other_data.dietFoodData[ele].properties[0].time = this.consultation.other_data.dietFoodData[ele].properties[0].timeDate.toTimeString().split(" ")[0].slice(0, 5);
    //         this.consultation.consultApiData.patient_dietary_data.push(this.consultation.other_data.dietFoodData[ele]);
    //     }
    // });
    this.consultation.consultApiData.patient_dietary_data = null;
  }

  async submitConsultation(): Promise<void> {
    this.consultation.other_data.submit_consultation_api_result = new ApiResult(
      true
    );
    this.consultation.other_data.payment_data.payment_start_api_result =
      new ApiResult(true);
    // for normal consultation ui will handle slot bdoctor choose
    // only for preferred slot this slot doctor choose will set
    this.consultation.setSlotDoctorChoose();
    this.consultation.other_data.payment_data = new Payment_Data();
    this.consultation.consultApiData.additional_offers =
      this.consultation.other_data.selected_additional_offer != null
        ? [this.consultation.other_data.selected_additional_offer]
        : [];
    if (this.isNutritionAndHealthConsultation()) {
      // form backend its going to change the specialty id during api call so sending random value
      this.consultation.consultApiData.specialty_id = [1];
    }
    await this.patientService
      .consultDoctor(this.consultation.consultApiData)
      .toPromise()
      .then(async (result) => {
        this.consultation.other_data.submit_consultation_api_result.PromiseResult =
          result;
        if (result.success) {
          this.consultation.other_data.payment_data.stripe_checkout_url = result.data.stripe_checkout_url;
          if (result.data.consultation_request_number == null) {
            const order: order_model = result.data;
            this.consultation.other_data.payment_data.payment_start_api_result.PromiseResult =
              result;
            this.consultation.other_data.payment_data.order_data = order;
            await this.start_payment();
            this.consultation.other_data.tabview_Data.nextTab(
              CONSULTATION_FORMS_TABS.PAYMENT_FORMS
            );
          } else {

            this.consultation.other_data.payment_data.paymentSuccessData.consultationData.consultation_request_number =
              result.data.consultation_request_number;
            this.consultation.other_data.tabview_Data.nextTab(
              CONSULTATION_FORMS_TABS.PAYMENT_SUCCESS
            );
          }
        }
        this.consultation.other_data.payment_data.payment_start_api_result.Posting =
          false;
        this.consultation.other_data.submit_consultation_api_result.Posting =
          false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultation.other_data.submit_consultation_api_result.ServerError =
          error.error;
        this.consultation.other_data.submit_consultation_api_result.PromiseResult.success =
          false;
        this.consultation.other_data.submit_consultation_api_result.Posting =
          false;
        this.consultation.other_data.payment_data.payment_start_api_result.ServerError =
          error.error;
        this.consultation.other_data.payment_data.payment_start_api_result.PromiseResult.success =
          false;
        this.consultation.other_data.payment_data.payment_start_api_result.Posting =
          false;
      });
  }

  async getPackages() {
    this.consultation.reset_pay_data();
    this.consultation.reset_package_status_data();
    this.consultation.reset_user_package_id();
    this.consultation.resetPackageData();
    if (
      this.consultation.consultApiData.consultation_type_id != null &&
      this.consultation.consultApiData.patient_guid != null
    ) {
      this.consultation.other_data.user_packages_list_api_result =
        new ApiResult(true);
      this.consultation.other_data.packageConsultDoctor.apiData = {
        patient_guid: this.consultation.consultApiData.patient_guid,
        consultation_type_id:
          this.consultation.consultApiData.consultation_type_id
      };

      await this.patientService
        .findPackages(this.consultation.other_data.packageConsultDoctor.apiData)
        .toPromise()
        .then((result) => {
          this.consultation.other_data.user_packages_list_api_result.PromiseResult =
            result;
          if (result.success) {
            this.consultation.other_data.packages_status_data =
              result.data.packages;
            if (this.consultation.other_data.packages_status_data.length > 0) {
              this.consultation.other_data.is_pay = false;
              this.consultation.other_data.packages_status_data.forEach(
                (ele, index) => {
                  let final_name: string =
                    ele.package_type.package_name;
                  final_name = final_name.split('(N/A)')[0];
                  ele.final_name = final_name;
                }
              );
              this.consultation.consultApiData.user_package_id =
                this.consultation.other_data.packages_status_data[0].id;
              this.setPackageOtherData(
                this.consultation.other_data.packages_status_data[0]
              );
            }
          }
          this.consultation.other_data.user_packages_list_api_result.Posting =
            false;
        })
        .catch((error: HttpErrorResponse) => {
          this.consultation.other_data.user_packages_list_api_result.ServerError =
            error.error;
          this.consultation.other_data.user_packages_list_api_result.PromiseResult.success =
            false;
          this.consultation.other_data.user_packages_list_api_result.Posting =
            false;
        });
    }
  }

  setPackageOtherData(data: PackageStatusModel) {
    const data_upc: ConsultationStatusModel = data.user_package_count[0];
    if (data.package_type.vendor_guid != null) {
      this.consultation.other_data.packageConsultDoctor.otherData.consultationDisabled =
        true;
      this.consultation.consultApiData.consultation_type_id =
        data_upc.consultation_type_id;
    }

    if (data_upc.specialty_id != null) {
      this.consultation.other_data.packageConsultDoctor.otherData.specialtyHide =
        true;
      this.consultation.other_data.packageConsultDoctor.otherData.specialty_name =
        data_upc.d_specialty_type.specialty_name;
      this.consultation.other_data.selectedSpecialtyId = data_upc.specialty_id;
      this.consultation.consultApiData.specialty_id = [data_upc.specialty_id];
    }

    if (data_upc.priority_type_id != null) {
      this.consultation.other_data.packageConsultDoctor.otherData.priorityDisabled =
        true;
      this.consultation.other_data.packageConsultDoctor.otherData.priority_type_id =
        data_upc.priority_type_id;
    }

    this.consultation.other_data.slotsFetch.api_data.vendor_guid =
      data.package_type.vendor_guid;
    this.consultation.other_data.slotsFetch.other_data.is_display =
      data.package_type.vendor_guid != null;
    this.consultation.other_data.packageConsultDoctor.otherData.packagesDiabled =
      data.package_type.vendor_guid != null;

    if (this.consultation.other_data.slotsFetch.other_data.is_display) {
      this.consultation.consultApiData.slot_doctor_choose = false;
    }

    if (
      this.consultation.consultApiData.consultation_type_id ==
      CONSULTATION_TYPES.NUTRITION_AND_HEALTH_CONSULTATION
    ) {
      this.consultation.other_data.is_package_diet = true;
    }
  }

  async setDietData(result: PromiseResult) {
    let data: Nutrition_Health_Consultation_Plans_List[] = [];
    if (result.success) {
      if (result.data.priority.length > 0) {
        if (!this.consultation.other_data.is_package_diet) {
          result.data.priority.forEach((ele) => {
            let is_free = Number(ele.amount) == 0;
            data.push({
              amount: ele.amount,
              consultation_name: ele.consultation_name,
              description: ele.description,
              id: ele.id,
              image_url: ele.image_url,
              isFree: is_free,
              number_of_consultations: ele.number_of_consultations,
              raw_amount: ele.amount,
              value: {
                id: ele.id,
                isFree: is_free
              }
            });
          });
        } else {
          let temp_data = [result.data.priority[0]];
          temp_data.forEach((ele) => {
            let is_free = Number(ele.amount) == 0;
            data.push({
              amount: ele.amount,
              consultation_name: ele.consultation_name,
              description: ele.description,
              id: ele.id,
              image_url: ele.image_url,
              isFree: is_free,
              number_of_consultations: ele.number_of_consultations,
              raw_amount: ele.amount,
              value: {
                id: ele.id,
                isFree: is_free
              }
            });
          });
        }
      }
    } else {
      data = [];
    }
    this.consultation.other_data.nutritionHealthCons.plans.plans_list = data;
  }

  async getDietPreference(): Promise<void> {
    this.consultation.other_data.diet_preference_list_api_result =
      new ApiResult(true);
    await this.patientService
      .getDietPreference()
      .toPromise()
      .then((result) => {
        this.consultation.other_data.diet_preference_list_api_result.PromiseResult =
          result;
        if (result.success) {
          this.consultation.other_data.dietPreferenceData =
            this.utilitiesService.getSelectItemList(
              result.data.diet_types,
              'diet_type',
              'id',
              false
            );
        }
        this.consultation.other_data.diet_preference_list_api_result.Posting =
          false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultation.other_data.diet_preference_list_api_result.ServerError =
          error.error;
        this.consultation.other_data.diet_preference_list_api_result.PromiseResult.success =
          false;
        this.consultation.other_data.diet_preference_list_api_result.Posting =
          false;
      });
  }

  async getDietitionList(): Promise<void> {
    this.consultation.other_data.dietition_list_api_result = new ApiResult(
      true
    );
    let data: fetchAllData = new fetchAllData();
    data.is_diet = true;
    data.provider_id = this.provider_id;
    await this.doctorService
      .getFetchAllActiveUsers(data)
      .toPromise()
      .then((result) => {
        this.consultation.other_data.dietition_list_api_result.PromiseResult =
          result;
        if (result.success) {
          result.data.data.forEach((ele) => {
            ele.full_name =
              ele.first_name + ' ' + (ele.middle_name == null ? '' : ele.middle_name) + ' ' + ele.last_name;
          });
          this.consultation.other_data.preferredDieticianData =
            this.utilitiesService.getSelectItemList(
              result.data.data,
              'full_name',
              'user_guid',
              false
            );
        }
        this.consultation.other_data.dietition_list_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultation.other_data.dietition_list_api_result.ServerError =
          error.error;
        this.consultation.other_data.dietition_list_api_result.PromiseResult.success =
          false;
        this.consultation.other_data.dietition_list_api_result.Posting = false;
      });
  }

  async getMemberList(): Promise<void> {
    this.consultation.other_data.members_list_api_result = new ApiResult(true);
    await this.patientService
      .getMember(sessionStorage.getItem('userid'))
      .toPromise()
      .then((result) => {
        this.consultation.other_data.members_list_api_result.PromiseResult =
          result;
        if (result.success) {
          result.data.patient.forEach((ele) => {
            ele.full_name =
              ele.first_name + ' ' + (ele.middle_name == null ? '' : ele.middle_name) + ' ' + ele.last_name;
            this.consultation.patient_state[ele.patient_guid] = ele.state_id;
            // this.consultation.other_data.patient_profile_complete[ele.patient_guid] = ele.profile_complete;
            this.consultation.other_data.patient_country_map[ele.patient_guid] =
              ele.country_id;
          });

          this.consultation.other_data.members_data =
            this.utilitiesService.getSelectItemList(
              result.data.patient,
              'full_name',
              'patient_guid',
              false
            );
          if (this.consultation.other_data.members_data.length > 0) {
            this.consultation.consultApiData.patient_guid =
              this.consultation.other_data.members_data[0].value;
          }
        }
        this.consultation.other_data.members_list_api_result.Posting = false;

        //this.selectedMember=result.data.patient[0];
      })
      .catch((error: HttpErrorResponse) => {
        this.consultation.other_data.members_list_api_result.ServerError =
          error.error;
        this.consultation.other_data.members_list_api_result.PromiseResult.success =
          false;
        this.consultation.other_data.members_list_api_result.Posting = false;
      });
  }

  async getStates() {
    let country_id =
      this.consultation.other_data.patient_country_map[
      this.consultation.consultApiData.patient_guid
      ];
    await this.countriesService
      .getStates(country_id)
      .toPromise()
      .then((result) => {
        result.map((ele) => {
          ele['state_data'] = {
            id: ele.id.toString(),
            name: ele.state_name.toString()
          };
        });
        this.consultation.other_data.p_editdata.other_data.states =
          this.utilitiesService.getSelectItemList(
            result,
            'state_name',
            'state_data'
          );
      })
      .catch((err: HttpErrorResponse) => {
        console.error(err);
      });
  }

  async getSpecialty(patient_guid: string, common_health_id?: number, provider_id?: string) {
    this.consultation.other_data.specialty_list_api_result = new ApiResult(
      true
    );
    await this.specialtyService
      .GetAllSupportedPatient(patient_guid, common_health_id, provider_id)
      .toPromise()
      .then(async (result) => {
        this.consultation.other_data.specialty_list_api_result.PromiseResult =
          result;
        // const sp: SupportedSpecialty[] = result.data
        if (result.success) {
          this.consultation.other_data.specialty_data =
            this.utilitiesService.getSelectItemList(
              result.data,
              'specialty_name',
              'id',
              false
            );
          if (this.consultation.other_data.specialty_data.length == 1) {
            this.consultation.other_data.selectedSpecialtyId =
              this.consultation.other_data.specialty_data[0].value;
            await this.onSpecialityChange();
          }
        }
        this.consultation.other_data.specialty_list_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultation.other_data.specialty_list_api_result.ServerError =
          error.error;
        this.consultation.other_data.specialty_list_api_result.PromiseResult.success =
          false;
        this.consultation.other_data.specialty_list_api_result.Posting = false;
      });
  }

  async getFollowUpConsultations() {
    if (this.consultation.consultApiData.patient_guid) {
      let close_consultation_data: SelectItem[] = [];
      this.consultation.other_data.closed_consultation_list_api_result =
        new ApiResult(true);
      await this.patientService
        .getClosedConsultation(this.consultation.consultApiData.patient_guid)
        .toPromise()
        .then((result) => {
          this.consultation.other_data.closed_consultation_list_api_result.PromiseResult =
            result;
          if (result.success) {
            close_consultation_data = this.utilitiesService.getSelectItemList(
              result.data,
              'consultation_request_number',
              '',
              false
            );
          }
          this.consultation.other_data.closed_consultation_list_api_result.Posting =
            false;
        })
        .catch((error: HttpErrorResponse) => {
          this.consultation.other_data.closed_consultation_list_api_result.ServerError =
            error.error;
          this.consultation.other_data.closed_consultation_list_api_result.PromiseResult.success =
            false;
          this.consultation.other_data.closed_consultation_list_api_result.Posting =
            false;
        });
      this.consultation.other_data.close_consultation_data =
        close_consultation_data;
    }
  }

  async getPriorityList(): Promise<void> {
    this.consultation.resetPriorityID();
    if (
      this.consultation.consultApiData.patient_guid &&
      this.consultation.consultApiData.consultation_type_id > 0
    ) {
      this.consultation.other_data.priority_list_api_result = new ApiResult(
        true
      );
      this.consultation.resetPriorityList();

      await this.patientService
        .getPriorityByGuid(
          this.consultation.consultApiData.patient_guid,
          this.consultation.consultApiData.consultation_type_id,
          this.consultation.other_data.selectedSpecialtyId,
          this.consultation.consultApiData.user_package_id
        )
        .toPromise()
        .then(async (result) => {
          this.consultation.other_data.priority_list_api_result.PromiseResult =
            result;
          if (result.success) {
            this.consultation.other_data.priority_list = result.data.priority;
            this.consultation.other_data.offers = result.data.additional_offers;
            this.consultation.other_data.priority_list.forEach((ele) => {
              ele.price_label =
                ele.p_priority_doctor_origin.country.country_name +
                ' (' +
                this.renderAmount(ele.amount, ele.country.currency_type) +
                ')';
              ele.no_price_label =
                ele.p_priority_doctor_origin.country.country_name;
            });
            if (
              this.consultation.other_data.packageConsultDoctor.otherData
                .priorityDisabled
            )
              this.consultation.consultApiData.priority_type_id =
                this.consultation.other_data.packageConsultDoctor.otherData.priority_type_id;
            else
              this.consultation.consultApiData.priority_type_id =
                this.consultation.other_data.priority_list[0].id;
            this.ResetSlots();
          }
          if (this.isNutritionAndHealthConsultation()) {
            await this.setDietData(result);
            await this.setDietDataValues();
          }
          this.consultation.other_data.priority_list_api_result.Posting = false;
        })
        .catch((error: HttpErrorResponse) => {
          this.consultation.other_data.priority_list_api_result.ServerError =
            error.error;
          this.consultation.other_data.priority_list_api_result.PromiseResult.success =
            false;
          this.consultation.other_data.priority_list_api_result.Posting = false;
        });
    }
  }

  async getDiscountList(patient_guid: string) {
    this.consultation.other_data.discount_list_api_result = new ApiResult(true);
    this.consultation.consultApiData.discount_id = null;
    let temp: CouponCode[] = [];
    await this.refferalDiscountService
      .getPatientApplicableDiscountCopounList(patient_guid)
      .toPromise()
      .then((result) => {
        this.consultation.other_data.discount_list_api_result.PromiseResult =
          result;
        if (result.success) {
          if (result.data.discounts.length > 0) {
            result.data.discounts.forEach((element, ele_index) => {
              temp.push({
                index: ele_index,
                discount_id: element.discount_id,
                discount_code: element.discount_code,
                discount_percent: element.discount_percent,
                egd_referral_master_type: {
                  referral_type: element.egd_referral_master_type.referral_type
                }
              });
            });
          }
        }
        this.consultation.other_data.discountCodeList = temp;
        this.consultation.other_data.discount_list_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultation.other_data.discount_list_api_result.ServerError =
          error.error;
        this.consultation.other_data.discount_list_api_result.PromiseResult.success =
          false;
        this.consultation.other_data.discount_list_api_result.Posting = false;
      });
  }

  async applyDiscount() {
    this.consultation.other_data.discount_code_apply_api_result = new ApiResult(
      true
    );
    this.consultation.other_data.coupon_code_data.discount_code_api.patient_guid =
      this.consultation.consultApiData.patient_guid;
    await this.refferalDiscountService
      .applyDiscountCodeAtConsultation(
        this.consultation.other_data.coupon_code_data.discount_code_api
      )
      .toPromise()
      .then((result) => {
        this.consultation.other_data.discount_code_apply_api_result.PromiseResult =
          result;
        if (result.success) {
          this.consultation.consultApiData.discount_id =
            result.data.discount_id;
          this.consultation.other_data.discount_code_apply_api_result.ErrorModel.message =
            'The Code Has Been Applied, Click Save and Pay to get more information';
        } else {
          this.consultation.other_data.coupon_code_data.discount_code_api.discount_code =
            '';
        }
        this.consultation.other_data.discount_code_apply_api_result.Posting =
          false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultation.other_data.discount_code_apply_api_result.ServerError =
          error.error;
        this.consultation.other_data.discount_code_apply_api_result.PromiseResult.success =
          false;
        this.consultation.other_data.discount_code_apply_api_result.Posting =
          false;
      });
  }

  async openInvoice() {
    this.consultation.other_data.print_data.api_result = new ApiResult(true);
    this.consultation.other_data.print_data.displayModal = true;
    await this.patientService
      .fetchInvoice(
        this.consultation.other_data.payment_data.paymentSuccessData
          .consultationData.transaction_id
      )
      .toPromise()
      .then((result) => {
        this.consultation.other_data.print_data.api_result.PromiseResult =
          result;
        if (result.success) {
          this.consultation.other_data.print_data.data = result.data;
        } else {
          this.consultation.other_data.print_data.api_result.ErrorModel =
            result.error;
        }
        this.consultation.other_data.print_data.api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultation.other_data.print_data.api_result.ServerError =
          error.error;
        this.consultation.other_data.print_data.api_result.PromiseResult.success =
          false;
        this.consultation.other_data.print_data.api_result.Posting = false;
      });
  }

  print() {
    window.print();
  }

  async start_payment() {
    this.changeDetector.detectChanges();
    await this.payment_screen.load_payment_gateway();
  }

  onPaymentSuccess(data: PaymentSuccessResult) {
    this.consultation.other_data.payment_data.paymentSuccessData = data;
    this.consultation.other_data.tabview_Data.selected_tab =
      CONSULTATION_FORMS_TABS.PAYMENT_SUCCESS;
    this.notDirty();
  }

  ResetSlots() {
    this.consultation.clear_slots();
    this.setDates();
  }

  async onSpecialityChange() {
    switch (this.consultation.consultApiData.consultation_type_id) {
      case this.consultation.const_data.CONSULTATION_TYPES
        .EXPERT_SECOND_MEDICAL_CONSULTATION:
        this.consultation.consultApiData.specialty_id = [
          this.consultation.other_data.selectedSpecialtyId
        ];
        await this.getPriorityList();
        break;
      case this.consultation.const_data.CONSULTATION_TYPES
        .PRIMARY_MEDICAL_CONSULTATION:
        this.consultation.consultApiData.specialty_id = [
          this.consultation.other_data.selectedSpecialtyId
        ];
        await this.getPriorityList();
        break;
      default:
        break;
    }
  }

  async onMemberChange() {
    await this.onDataChange();
  }

  async onPaymentChange() {
    this.consultation.resetPackageData();
    if (this.isPay()) {
      this.consultation.reset_user_package_id();
      this.consultation.other_data.is_package_diet = false;
    } else {
      //note this assumes that we only have one package at a time
      this.consultation.consultApiData.user_package_id =
        this.consultation.other_data.packages_status_data[0].id;
      this.setPackageOtherData(
        this.consultation.other_data.packages_status_data[0]
      );
    }
    await this.getPriorityList();
  }

  isNutritionAndHealthConsultation(): boolean {
    return (
      this.consultation.consultApiData.consultation_type_id ===
      this.consultation.const_data.CONSULTATION_TYPES
        .NUTRITION_AND_HEALTH_CONSULTATION
    );
  }

  // isProfileComplete(): boolean {
  //     return this.consultation.other_data.patient_profile_complete[this.consultation.consultApiData.patient_guid];
  // }

  isOtherDietPreference(): boolean {
    return this.consultation.consultApiData.diet_preferrence_id == 3;
  }

  isConsultationForm(): boolean {
    if (this.isNutritionAndHealthConsultation()) {
      return this.consultation.other_data.selectedDietPlan != null;
    }
    return true;
  }

  async onDataChange() {
    // need to reset values so adding the common consultaion and member changes function
    this.consultation.resetSpecialties();
    this.consultation.resetSelectedDietPlan();
    this.consultation.resetFollowUpConultationID();
    this.consultation.consultApiData.is_followup =
      this.consultation.consultApiData.consultation_type_id ===
      this.consultation.const_data.CONSULTATION_TYPES.FOLLOW_UP_CONSULTATION;
    if (this.isFollowUp()) {
      await this.getFollowUpConsultations();
    } else {
      this.consultation.consultApiData.followup_consultation_id = 1;
    }
    await this.getPackages();
    await this.getPriorityList();
    await this.getSpecialty(this.consultation.consultApiData.patient_guid, undefined, this.provider_id);
  }

  async onSlotsDateChanged(selected_date: Date) {
    this.consultation.other_data.slotsFetch.api_result = new ApiResult(true);
    this.consultation.resetPreferredSlot();
    this.consultation.other_data.slotsFetch.timeSlots.timeSlots_api_data = [];
    this.consultation.other_data.slotsFetch.timeSlots.timeSlots = [];
    this.consultation.other_data.slotsFetch.api_data.slot_date =
      this.daterenderService.render_data(selected_date);
    this.consultation.other_data.slotsFetch.api_data.primary_speciality_id =
      this.consultation.other_data.selectedSpecialtyId;
    await this.patientService
      .getSlotsForConsultation(this.consultation.other_data.slotsFetch.api_data)
      .toPromise()
      .then((result) => {
        this.consultation.other_data.slotsFetch.api_result.PromiseResult =
          result;
        if (result.success) {
          this.consultation.other_data.slotsFetch.timeSlots.timeSlots_api_data =
            result.data;
        }
        this.changeDetector.detectChanges();
        this.time_slots_screen.slotsDataGenerate();
        this.consultation.other_data.slotsFetch.api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.consultation.other_data.slotsFetch.api_result.ServerError =
          error.error;
        this.consultation.other_data.slotsFetch.api_result.PromiseResult.success =
          false;
        this.consultation.other_data.slotsFetch.api_result.Posting = false;
      });
  }

  onSlotSelected(slot_id: number) {
    this.consultation.consultApiData.preferred_slot_id = slot_id;
  }

  async onConsultationChange() {
    await this.onDataChange();
  }

  async onClosedConsultationChange() {
    this.consultation.consultApiData.specialty_id =
      this.consultation.other_data.selectedClosedConsultation.p_consultation_appointment.map(
        (ele) => {
          return ele.specialty_id;
        }
      );
    this.consultation.other_data.selectedSpecialtyId =
      this.consultation.consultApiData.specialty_id[0];
    this.consultation.consultApiData.followup_consultation_id =
      this.consultation.other_data.selectedClosedConsultation.id;
    await this.getPriorityList();
  }

  setDates() {
    const now = new Date();
    this.consultation.other_data.minDays = now;
    this.consultation.other_data.maxDays = this.dateUtilService.addQuantity(now, 21, moment_duration.days);
    this.consultation.other_data.maxDays = this.dateUtilService.getDateResettingTime(this.consultation.other_data.maxDays);
  }


  isPackageSpecialty(): boolean {
    return this.consultation.other_data.packageConsultDoctor.otherData
      .specialtyHide;
  }

  isSpecialtyDisplay(): boolean {
    switch (this.consultation.consultApiData.consultation_type_id) {
      case this.consultation.const_data.CONSULTATION_TYPES
        .PRIMARY_MEDICAL_CONSULTATION:
        return true;
      case this.consultation.const_data.CONSULTATION_TYPES
        .EXPERT_SECOND_MEDICAL_CONSULTATION:
        return true;
      case this.consultation.const_data.CONSULTATION_TYPES
        .MULTI_SPECIALTY_CONSULTATION:
        return true;
      case this.consultation.const_data.CONSULTATION_TYPES
        .FOLLOW_UP_CONSULTATION:
        return true;
      case this.consultation.const_data.CONSULTATION_TYPES
        .NUTRITION_AND_HEALTH_CONSULTATION:
        return false;

      default:
        console.error(
          'Error',
          this.consultation.consultApiData.consultation_type_id
        );
        return true;
    }
  }

  getCardBorder(type: string, id: any) {
    let style = {};
    if (type === 'additional_offer') {
      if (this.consultation.other_data.selected_additional_offer == id) {
        style['border'] = '2px solid #004aad';
      } else {
        style['border'] = '2px solid transparent';
      }
    }
    if (type === 'discount_code') {
      if (this.consultation.consultApiData.discount_id == id) {
        style['border'] = '2px solid #004aad';
      } else {
        style['border'] = '2px solid transparent';
      }
    }
    return style;
  }

  additonalOffersBtn(id: any) {
    this.consultation.other_data.selected_additional_offer =
      this.consultation.other_data.selected_additional_offer == id ? null : id;
  }

  async discountCodeApplyBtn() {
    await this.applyDiscount();
  }

  discountCodeViewBtn() {
    // let minimum_count = this.consultation.other_data.discountCodeList.length < 3 ? this.consultation.other_data.discountCodeList.length : 3;
    this.consultation.other_data.coupon_code_data.current_list_count = this
      .consultation.other_data.coupon_code_data.show_all
      ? 3
      : this.consultation.other_data.discountCodeList.length;
    this.consultation.other_data.coupon_code_data.show_all =
      !this.consultation.other_data.coupon_code_data.show_all;
  }

  discountCodeBtn(id: string, code_string: string) {
    this.consultation.consultApiData.discount_id =
      this.consultation.consultApiData.discount_id == id ? null : id;
    if (this.consultation.consultApiData.discount_id == id) {
      this.consultation.other_data.coupon_code_data.discount_code_api.discount_code =
        code_string;
      this.consultation.other_data.discount_code_apply_api_result.PromiseResult.success =
        true;
      this.consultation.other_data.discount_code_apply_api_result.ErrorModel.message =
        'The Code Has Been Applied, Click Save and Pay to get more information';
    } else {
      this.consultation.other_data.coupon_code_data.discount_code_api.discount_code =
        '';
      this.consultation.other_data.discount_code_apply_api_result =
        new ApiResult(false);
    }
  }

  canLeave(): boolean {
    if (
      this.consultation.other_data.component_leave.Fu ||
      this.consultation.other_data.component_leave.sc
    ) {
      return window.confirm('Are You Sure that you Want To Leave This Page?');
    }
    //return window.confirm('Are You Sure  You Want To Leave This Page?');
    return true;
  }

  notDirty() {
    this.consultation.other_data.component_leave.sc = false;
    this.consultation.other_data.component_leave.Fu = false;
  }

  dirty() {
    this.consultation.other_data.component_leave.sc = true;
  }

  isPay(): boolean {
    return this.consultation.other_data.is_pay;
  }

  isFreeDietConsultation() {
    return this.consultation.other_data.selectedDietPlan != null
      ? this.consultation.other_data.selectedDietPlan.isFree
      : true;
  }

  // async profileCompletionFormSubmit() {
  //     this.consultation.other_data.p_editdata.patient_update_api_result = new ApiResult(true);
  //     this.consultation.other_data.p_editdata.profileCompletion.patient_guid = this.consultation.consultApiData.patient_guid;
  //     this.consultation.other_data.p_editdata.profileCompletion.state_name = this.consultation.other_data.p_editdata.profileCompletion.selectedState.name;
  //     this.consultation.other_data.p_editdata.profileCompletion.state_id = this.consultation.other_data.p_editdata.profileCompletion.selectedState.id;
  //     this.consultation.other_data.p_editdata.profileCompletion.date_of_birth = this.daterenderService.render_data(this.consultation.other_data.p_editdata.profileCompletion.date_of_birth_date);
  //     this.consultation.other_data.p_editdata.form_data.form_data = this.consultation.other_data.p_editdata.form_data.create_form_data(this.consultation.other_data.p_editdata.profileCompletion, new FormData(), "");

  //     await this.patientService
  //         .UpdateProfile(this.consultation.other_data.p_editdata.form_data.form_data)
  //         .toPromise()
  //         .then(result => {
  //             this.consultation.other_data.p_editdata.patient_update_api_result.PromiseResult = result;
  //             if (result.success) {
  //                 this.consultation.other_data.patient_profile_complete[this.consultation.consultApiData.patient_guid] = true;
  //                 this.consultation.other_data.p_editdata.patient_update_api_result.ErrorModel.message = "Member data updated successfully.";
  //             }
  //             this.consultation.other_data.p_editdata.patient_update_api_result.Posting = false;
  //         }).catch((error: HttpErrorResponse) => {
  //             this.consultation.other_data.p_editdata.patient_update_api_result.ServerError = error.error;
  //             this.consultation.other_data.p_editdata.patient_update_api_result.PromiseResult.success = false;
  //             this.consultation.other_data.p_editdata.patient_update_api_result.Posting = false;
  //         });
  // }

  async nextTab() {
    switch (this.consultation.other_data.tabview_Data.selected_tab) {
      case CONSULTATION_FORMS_TABS.CONSULTATION_FORM:
        if (this.isNutritionAndHealthConsultation()) {
          //-->nutrtional consulatation has free and paid consultation
          this.consultation.consultApiData.priority_type_id =
            this.consultation.other_data.selectedDietPlan.id;
          // if (this.isFreeDietConsultation()) {
          //     this.consultation.other_data.tabview_Data.nextTab(CONSULTATION_FORMS_TABS.NUTRITIONAL_ASSESSMENT_FORM);
          // }
          // else {
          this.consultation.other_data.tabview_Data.nextTab(
            CONSULTATION_FORMS_TABS.PAID_DIET_FORM
          );
          // }
        } else {
          if (this.isPay() && this.is_primary_provider) {
            //--> packages not used
            // await this.getRecommendedPackages();
            await this.getDiscountList(
              this.consultation.consultApiData.patient_guid
            );
            this.consultation.other_data.tabview_Data.nextTab(
              CONSULTATION_FORMS_TABS.OFFERS_FORM
            );
          } else {
            //-->package used
            await this.submitConsultation();
          }
        }
        break;
      // case CONSULTATION_FORMS_TABS.NUTRITIONAL_ASSESSMENT_FORM:
      //     await this.submitNutritionAssessmentForm();
      //     await this.submitConsultation();
      //     break;
      case CONSULTATION_FORMS_TABS.PAID_DIET_FORM:
        if (!this.isFreeDietConsultation()) {
          await this.getDiscountList(
            this.consultation.consultApiData.patient_guid
          );
          this.consultation.other_data.tabview_Data.nextTab(
            CONSULTATION_FORMS_TABS.OFFERS_FORM
          );
        } else {
          await this.submitNutritionAssessmentForm();
          await this.submitConsultation();
        }
        break;
      case CONSULTATION_FORMS_TABS.OFFERS_FORM:
        // await this.getRecommendedPackages();
        await this.submitConsultation();
        break;
      default:
        break;
    }
  }

  handleClearMessages() {
    //this.prevTab();

    const submitResult = this.consultation.other_data.submit_consultation_api_result;
    const discountResult = this.consultation.other_data.discount_code_apply_api_result;

    if (submitResult.ServerError && submitResult.ServerError.message) {
      if (typeof submitResult.ServerError.message === 'string') {
        submitResult.ServerError.message = '';
      } else if (Array.isArray(submitResult.ServerError.message)) {
        submitResult.ServerError.message = [];
      }
    }

    if (submitResult.ErrorModel && submitResult.ErrorModel.message) {
      submitResult.ErrorModel.message = '';
    }

    if (submitResult.PromiseResult && submitResult.PromiseResult.error && submitResult.PromiseResult.error.message) {
      submitResult.PromiseResult.error.message = '';
    }

    if (discountResult.ServerError && discountResult.ServerError.message) {
      if (typeof discountResult.ServerError.message === 'string') {
        discountResult.ServerError.message = '';
      } else if (Array.isArray(discountResult.ServerError.message)) {
        discountResult.ServerError.message = [];
      }
    }

    if (discountResult.ErrorModel && discountResult.ErrorModel.message) {
      discountResult.ErrorModel.message = '';
    }

    if (discountResult.PromiseResult && discountResult.PromiseResult.error && discountResult.PromiseResult.error.message) {
      discountResult.PromiseResult.error.message = '';
    }
  }


  async prevTab() {
    switch (this.consultation.other_data.tabview_Data.selected_tab) {
      // case CONSULTATION_FORMS_TABS.NUTRITIONAL_ASSESSMENT_FORM:
      //     this.consultation.other_data.tabview_Data.prevTab(CONSULTATION_FORMS_TABS.CONSULTATION_FORM);
      //     break;
      case CONSULTATION_FORMS_TABS.PAID_DIET_FORM:
        this.consultation.other_data.tabview_Data.prevTab(
          CONSULTATION_FORMS_TABS.CONSULTATION_FORM
        );
        break;
      case CONSULTATION_FORMS_TABS.OFFERS_FORM:
        if (this.isNutritionAndHealthConsultation()) {
          // if (!this.isFree()) {
          this.consultation.other_data.tabview_Data.prevTab(
            CONSULTATION_FORMS_TABS.PAID_DIET_FORM
          );
          // }
        } else {
          this.consultation.other_data.tabview_Data.prevTab(
            CONSULTATION_FORMS_TABS.CONSULTATION_FORM
          );
        }
        break;
      case CONSULTATION_FORMS_TABS.PAYMENT_FORMS:
        this.consultation.other_data.tabview_Data.prevTab(
          CONSULTATION_FORMS_TABS.OFFERS_FORM
        );
        break;
      default:
        break;
    }
  }

  isPrevDisabled(): boolean {
    return (
      this.consultation.other_data.tabview_Data.min_tab ===
      this.consultation.other_data.tabview_Data.selected_tab
    );
  }

  isNextDisabled(): boolean {
    return (
      this.consultation.other_data.tabview_Data.max_tab ===
      this.consultation.other_data.tabview_Data.selected_tab
    );
  }

  isFollowUp(): boolean {
    return this.consultation.consultApiData.is_followup;
  }

  isPosting(): boolean {
    return (
      this.consultation.other_data.form_api_result.Posting ||
      this.consultation.other_data.user_packages_list_api_result.Posting ||
      this.consultation.other_data.nutritionHealthCons.plans.api_result
        .Posting ||
      // this.consultation.other_data.packages_form_api_result.Posting ||
      this.consultation.other_data.members_list_api_result.Posting ||
      this.consultation.other_data.specialty_list_api_result.Posting ||
      this.consultation.other_data.priority_list_api_result.Posting ||
      this.consultation.other_data.discount_list_api_result.Posting ||
      this.consultation.other_data.discount_code_apply_api_result.Posting ||
      this.consultation.other_data.submit_consultation_api_result.Posting ||
      this.consultation.other_data.diet_preference_list_api_result.Posting ||
      this.consultation.other_data.dietition_list_api_result.Posting ||
      this.consultation.other_data.payment_data.transaction_submit_api_result
        .Posting ||
      this.consultation.other_data.payment_data.payment_start_api_result
        .Posting ||
      this.consultation.other_data.p_editdata.patient_update_api_result
        .Posting ||
      this.consultation.other_data.slotsFetch.api_result.Posting ||
      this.consultation.other_data.closed_consultation_list_api_result.Posting
    );
  }

  slotDate(case_no): boolean {
    switch (case_no) {
      // 1x means slot 1
      //      if x=0 it means from
      //      if x=1 it means to
      //      if x=2 it means invalid slot error
      // 10 means slot 1 from
      // 11 means slot 1 to
      // 12 means slot 1 invalid dates
      case 0:
        return this.slotDate(10) || this.slotDate(11) || this.slotDate(12);

      case 10:
        return (
          this.consultation.consultApiData.slot1_primary_from?.toDateString() ==
          this.consultation.other_data.todayDate.toDateString()
        );

      case 11:
        return (
          this.consultation.consultApiData.slot1_primary_to?.toDateString() ==
          this.consultation.other_data.todayDate.toDateString()
        );

      case 12:
        return (
          this.consultation.consultApiData.slot1_primary_to != null &&
          this.consultation.consultApiData.slot1_primary_from != null &&
          this.consultation.consultApiData.slot1_primary_from >=
          this.consultation.consultApiData.slot1_primary_to
        );

      default:
        console.error(case_no + ' invalid slot case chosen');
        break;
    }
  }

  renderAmount(amount: number | string, currency_type: string) {
    return this.utilitiesService.getRenderedAmount(
      Number(amount),
      currency_type
    );
  }

  genStyle(priority_type_id: number) {
    // const width = '300px';
    let style = {};
    if (priority_type_id == this.consultation.consultApiData.priority_type_id) {
      style['border'] = '2px solid #004aad';
    }
    return style;
  }

  text(data: ConsultationStatusModel[]) {
    let text = [];
    data.forEach((ele) => {
      text.push(ele.current_count + ' consultation left');
    });
    return text.toString();
  }

  RouterNavigation(path: string) {
    this.router.navigate(['/' + this.slug + '/patient/' + path]);
  }

  cancel() {
    if (!this.isSubmitting) {
      this.router.navigate(['/' + this.slug + '/patient/']);
    }
  }

  isConsultationSelected(): boolean {
    return this.consultation.consultApiData.consultation_type_id != null;
  }

  isMultiSpecialtyConsultation(): boolean {
    return (
      this.consultation.consultApiData.consultation_type_id ===
      this.consultation.const_data.CONSULTATION_TYPES
        .MULTI_SPECIALTY_CONSULTATION
    );
  }
  showOverlayPanel() {
    this.isOverlayPanelVisible = true;
  }

  hideOverlayPanel() {
    this.isOverlayPanelVisible = false;
  }
  uploadUniqueIDFiles(file: File[]) {
    if (this.image_types.includes(file[0].type.toLowerCase())) {
      if (file[0].size > 5033165) {
        this.identification = null;
      } else if (file[0].size < 5033165) {
        this.identification = file[0];
      }
    } else {
      this.identification = null;
    }
  }
  // onHide() {
  //     this.fileu = false;
  // }
  resetUnquieIDUpload() {
    this.identification = null;
  }
}
